import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import textBodySStrong from '@fukku/styles/texts/textBodySStrong.module.css'
import textHeadingS from '@fukku/styles/texts/textHeadingS.module.css'
import { ClientLabel } from 'labels/components/ClientLabel/ClientLabel'
import {
	EXPANDED_POLICY_LINK_TESTID,
	PRIVACY_POLICY_PAGE_PATHNAME,
} from '../../../../constants/privacyPolicy'
import styles from './ClientExpandedPolicy.module.css'

type ExpandedPolicyProps = {
	readonly title: string
	readonly body: string
	readonly id: string
}

export function ClientExpandedPolicy({ title, body, id }: ExpandedPolicyProps) {
	const placeholderValues = {
		PrivacyPolicy: PRIVACY_POLICY_PAGE_PATHNAME,
	}
	const linkProps = {
		'data-testid': `${id}.${EXPANDED_POLICY_LINK_TESTID}`,
		small: true,
	}

	return (
		<>
			<p className={`${textHeadingS.className} ${styles.policyTitle}`}>
				<ClientLabel>{title}</ClientLabel>
			</p>
			<p className={textBodyS.className}>
				<ClientLabel
					placeholderValues={placeholderValues}
					linkProps={linkProps}
					boldProps={{ className: textBodySStrong.className }}
				>
					{body}
				</ClientLabel>
			</p>
		</>
	)
}
